import _typeof from "@babel/runtime/helpers/typeof";
import { ProviderNames } from './types';

/**
 * Formats data into LinkIconData with appropriate Jira/Confluence favicon urls.
 * Undefined icons remain undefined.
 * Exported for testing purposes.
 *
 * Confluence favicon extension: /wiki/favicon.ico
 * Jira favicon extension: /favicon.ico
 *
 * @param jsonLd - raw JSON-LD data for an individual link
 */
export var formatLinkIconData = function formatLinkIconData(jsonLd) {
  var url = jsonLd.url,
    _jsonLd$generator = jsonLd.generator,
    name = _jsonLd$generator.name,
    icon = _jsonLd$generator.icon;
  switch (name) {
    case ProviderNames.CONFLUENCE:
      return {
        linkUrl: url,
        iconUrl: getConfluenceFavicon(url),
        productName: name
      };
    case ProviderNames.JIRA:
      return {
        linkUrl: url,
        iconUrl: getJiraFavicon(url),
        productName: name
      };
    default:
      return {
        linkUrl: url,
        iconUrl: _typeof(icon) === 'object' ? icon['url'] : icon,
        productName: name
      };
  }
};
var isIconItemSuccess = function isIconItemSuccess(response) {
  return response.status === 200;
};

/**
 * Converts batched list of json-ld responses into list of formatted LinkIconData { url, icon_url }
 *
 * @param batchResp - list of json-ld responses { body, status }
 */
export var transformIconData = function transformIconData(batchResp) {
  return batchResp.filter(isIconItemSuccess).map(function (resp) {
    return resp.body.data;
  }).map(formatLinkIconData).filter(function (linkIconData) {
    return linkIconData.iconUrl !== undefined;
  });
};
var getConfluenceFavicon = function getConfluenceFavicon(url) {
  return "https://".concat(new URL(url).hostname, "/wiki/favicon.ico");
};
var getJiraFavicon = function getJiraFavicon(url) {
  return "https://".concat(new URL(url).hostname, "/favicon.ico");
};